import React from "react"
import PropTypes from 'prop-types'

  // fill = "#CECFD2",
const GridList = ({
  style = {},
  width = "100%",
  className = "",
  viewBox = "0 0 100 100"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <path d="m67.5 89.582c-1.25 0-2.082-0.41797-2.918-1.25l-35.418-35.418c-1.668-1.668-1.668-4.168 0-5.832l35.418-35.418c1.668-1.668 4.168-1.668 5.832 0 1.668 1.668 1.668 4.168 0 5.832l-32.082 32.504 32.5 32.5c1.668 1.668 1.668 4.168 0 5.832-0.83203 0.83594-2.082 1.25-3.332 1.25z"/>
  </svg>
)

GridList.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default GridList
